// extracted by mini-css-extract-plugin
export default {"preview":"styles_preview__BxWgM","inner":"styles_inner__Tuizf","billboard":"styles_billboard__ihmXk","info":"styles_info__L7xX5"};